import { Divider, Paper } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { FC, useEffect, useState } from "react";
import { FaBarcode, FaFileAlt } from "react-icons/fa";
import { BOLETO_FINANCIAMENTO_INDIRETO, FINANCIMENTO_INDIRETO } from "src/constants";
import { StringUtil } from "src/framework/commons/StringUtil";
import { FullWidthButton } from "src/framework/components/buttons";
import api, { IDataRequest, STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store";
import { useObservable } from "src/framework/store/storeUtil";
import { formasPagamentoTextoInformativo$ } from "src/store/global.store";
import { BoletoType, CartaCreditoCartaType, CartaCreditoType, DocumentosPagamentosType, PedidoPagamento, PedidoType, TiposPagamentoIDType } from "src/types";
import { Boleto } from "../../boleto/Boleto";
import { FinanciamentoIndireto } from "../../financiamentoIndireto/FinanciamentoIndireto";
import { HeaderFormaPagamento } from "../HeaderFormaPagamento";
import "./styles.scss"

interface BoletoFinanciamentoIndiretoProperties {
    pedido: PedidoType | null;
    onConfirmar: (pagamento: PedidoPagamento, tipoPagamento: TiposPagamentoIDType, fecharPagamento: boolean) => void;
}

const BoletoFinanciamentoIndireto: FC<BoletoFinanciamentoIndiretoProperties> = ({
    pedido,
    onConfirmar,
}) => {
    const textoInformativo = useObservable(formasPagamentoTextoInformativo$);
    const [showFinanciamento, setShowFinanciamento] = useState<boolean>(false)
    const [texto, setTexto] = useState("");
    const [valorBoleto, setValorBoleto] = useState<number>(pedido?.valor_pendente || 0);
    const [valorCartaCredito, setValorCartaCredito] = useState<number>(0);
    const [pagamentoCartaCredito, setPagamentoCartaCredito] = useState<any>();
    const [disableConfirmar, setDisableConfirmar] = useState<boolean>(false);


    const saveArquivos = async (documentos: DocumentosPagamentosType[]): Promise<DocumentosPagamentosType[] | null> => {
        const url: string = `/pagamentos/cartas_credito/uploads/` + pedido?.codigo_venda;
        const documentosRetorno: DocumentosPagamentosType[] = [];

        let tudoCerto = true;

        if (documentos) {

            for (let doc of documentos) {

                const arquivoSplit = doc.arquivoSelecionado ? doc.arquivoSelecionado.split(".") : "";
                const arquivo = doc.sufixo_arquivo + "." + arquivoSplit[arquivoSplit.length - 1];

                const request: IDataRequest = {
                    url: url,
                    data: doc.formData,
                }

                const response = await api.post(request);
                if (response.statusCode !== STATUS_CODE.OK) {
                    tudoCerto = false;

                    break;
                }

                documentosRetorno.push({
                    ...doc,
                    url: response.data[arquivo].path,
                });
            };

            return documentosRetorno && tudoCerto ? documentosRetorno : null;
        }

        return null;
    }

    const validarDadosEnvio = (pedido: PedidoPagamento): boolean => {
        const messages = [];

        if (!pedido.itens) {
            messages.push("Forma pagamentos não informado!");
        }

        if (!pedido.itens.boletos) {
            messages.push("Boleto não informado!");
        } else if (pedido.itens.boletos.length === 0 || pedido.itens.boletos[0].valor <= 0) {
            messages.push("Não foi informado o valor do boleto!");
        }

        if (!pedido.itens.cartas_credito) {
            messages.push("Carta de Crédito não informada!");
        } else if (pedido.itens.cartas_credito.length === 0 || pedido.itens.cartas_credito[0].valor <= 0) {
            messages.push("Não foi informado o valor da carta de crédito!");
        } else if (!pedido.itens.cartas_credito[0].banco || pedido.itens.cartas_credito[0].banco === null) {
            messages.push("Não foi informado o banco da carta de crédito!");
        }

        if (messages.length > 0) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: messages,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)

            return false
        }

        return true;
    }

    const _valorPendente = (): number | null => {
        if (pedido) {
            let _valorEmPagamento: number = valorBoleto
            const _valorPendente = Number(((pedido?.valor_pendente || pedido?.valor_pagamento) - _valorEmPagamento).toFixed(2))
            return _valorPendente;
        }
        return null;
    }

    useEffect(() => {
        if (textoInformativo) {
            setTexto(StringUtil.retornaTextoInformativo(textoInformativo.data, BOLETO_FINANCIAMENTO_INDIRETO.id));
        }
    }, [textoInformativo])

    useEffect(() => {
        setDisableConfirmar(pedido?.codigo_cupom === null || pedido?.codigo_cupom === "");
    }, [])

    return <div className="BoletoFinanciamentoIndireto">

        <HeaderFormaPagamento
            icon={<><FaBarcode /></>}
            title={<>Boleto</>}
        />

        {texto ? <>
            <div className="row">
                <div className="X12">
                    <Alert severity="warning" className="texto-alerta">
                        {texto}
                    </Alert>
                </div>
            </div>
        </> : null}

        <Boleto
            disabled={showFinanciamento}
            onChangeValue={(value) => {
                setValorBoleto(value);
                if (pedido) {
                    const valor = pedido.valor_pendente - value || 0;

                    setValorCartaCredito(valor >= 0 ? valor : 0);
                    setValorBoleto(value || 0);
                }
            }}
            sizes={"X12 S6"}
            valor={valorBoleto}
        />

        {showFinanciamento && <>
            <div className="row">
                <div className="X12 header-financiamento">
                    <HeaderFormaPagamento
                        icon={<><FaFileAlt /></>}
                        title={<>Financiamento externo</>}
                        style={{ marginTop: "28px" }}
                    />
                </div>
            </div>
            <FinanciamentoIndireto
                checkout={true}
                formaPagamentoId={FINANCIMENTO_INDIRETO.id}
                codigoVenda={pedido?.codigo_venda || ""}
                cupomDesconto={pedido?.codigo_cupom || ""}
                valorPedido={valorCartaCredito}
                pagamentoId={pedido?.pagamento_id || 0}
                solo={false}
                disabledConfirmar={disableConfirmar}
                disableValorPagamento={true}
                exibirBotoes={false}
                onChangeValue={(value: any) => {
                    if (pedido) {
                        const valor = pedido.valor_pendente - value.valor || 0;

                        setValorBoleto(valor >= 0 ? valor : 0);

                        if (value.documentos && value.documentos.length > 0) {
                            setDisableConfirmar(false);
                        }

                        setPagamentoCartaCredito(value);
                    }
                }}
                onConfirmar={(value: any) => { }}
            />
        </>}
        <div className="row">
            {!showFinanciamento && <div className="X12 M6">
                <FullWidthButton
                    text="Adicionar boleto"
                    disabled={valorBoleto === 0 || (valorBoleto >= Number(pedido?.valor_pagamento))}
                    color="secondary"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        const valorPendente: number | null = _valorPendente();
                        if (valorPendente !== null) {
                            setValorCartaCredito(valorPendente)
                            setShowFinanciamento(true)
                        }
                    }}
                />
            </div>}
            {showFinanciamento && <div className="X12 M6">
                <FullWidthButton
                    text="Alterar valor do boleto"
                    color="default"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        setShowFinanciamento(false)
                        setDisableConfirmar(true)
                    }}
                />
            </div>}
            <div className="X12 M6">
                <FullWidthButton
                    text="Confirmar"
                    variant="contained"
                    color="primary"
                    disableElevation
                    disabled={disableConfirmar}
                    onClick={async () => {
                        if (pedido) {

                            const documentos = await saveArquivos(pagamentoCartaCredito.documentos);

                            const documentosCartas = documentos?.map((row: DocumentosPagamentosType) => {

                                const doc: CartaCreditoCartaType = {
                                    documento_pagamento_id: Number(row.id),
                                    url: row.url ? row.url : ""
                                }
                                return doc;
                            });

                            const pagamentosBoleto: BoletoType[] = [];

                            if (valorBoleto > 0) {
                                pagamentosBoleto.push({
                                    valor: valorBoleto,
                                    valor_original: valorBoleto
                                });
                            }
                            const cartaCredito: CartaCreditoType = {
                                valor: pagamentoCartaCredito.valor,
                                valor_original: pagamentoCartaCredito.valor,
                                banco: pagamentoCartaCredito.banco,
                                carta: documentosCartas ? documentosCartas : undefined,
                            }

                            const pedidoPagamento: PedidoPagamento = {
                                forma_pagamento: BOLETO_FINANCIAMENTO_INDIRETO.id,
                                pedido: pedido?.id,
                                itens: {
                                    boletos: pagamentosBoleto ? pagamentosBoleto : undefined,
                                    cartas_credito: cartaCredito ? [cartaCredito] : undefined,
                                }
                            }

                            if (!validarDadosEnvio(pedidoPagamento)) {
                                return false;
                            }

                            onConfirmar(pedidoPagamento, BOLETO_FINANCIAMENTO_INDIRETO.id as any, true)
                        }
                    }}
                />
            </div>
        </div>
    </div>
}

export { BoletoFinanciamentoIndireto }